const CartSummary = function () {
    const checkoutLegalModalSelector = '[data-remodal-id=modal-checkout-legal]';
    const checkoutRightColumnSelector = '.checkoutRight';
    const instantRedeemTutorialCookieName = 'INSTANT_REDEEM_COOKIE_TUTORIAL';
    const instantRedeemTutorialCookieDurationDays = 365;
    const instacartOtherAmountValue = '-1';
    let cartSummary = {};

    //****************************************************************
    // Init
    //****************************************************************
    const _init = function () {
        _manageStickySummarySize();
    };

    //****************************************************************
    // Ajax update
    //****************************************************************

    const _updateCartSummary = function (buttonVoucher, tipAppliedSuccess, callback) {
        var summary = $(checkoutRightColumnSelector);
        TINK.inProgress(summary);

        var forceUseLatestPrice = !$.isEmptyObject(cartSummary) && !$.isEmptyObject(cartSummary.priceLines);
        if (forceUseLatestPrice) {
            forceUseLatestPrice = false;
            cartSummary.priceLines.forEach(function (priceLine) {
                if (priceLine.priceType === 'TAX') {
                    forceUseLatestPrice = true;
                }
            });
        }

        var pageCheckoutStep; // 0 is cart
        if (typeof checkoutStep !== 'undefined') {
            pageCheckoutStep = checkoutStep;
        } else {
            pageCheckoutStep = $('.checkoutStepActive').last().data('checkout-step');
        }

        let uPassAisleSubTotal;
        if (typeof uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            uPassAisleSubTotal = uPass.getCartUPassAisleSubTotal(uPassAisleId);
        }

        let itemData = {
            checkoutStep: pageCheckoutStep,
            forceUseLatestPrice: forceUseLatestPrice,
            uPassAisleSubTotal: uPassAisleSubTotal,
            tipAppliedSuccess: typeof tipAppliedSuccess !== 'undefined' && tipAppliedSuccess
        };

        $.ajax({
            url: cartSummaryUrl,
            type: 'GET',
            data: itemData,
            headers: {
                'Accept-Language': lang
            },
            success: function (updatedCartSummary) {
                if ($('#cartGeniusModal.remodal-is-opened').length > 0 && window.location.pathname === shoppingCartUrl) {
                    /* Refresh the whole page if we add all from cart from cart genius */
                    window.location.reload();
                }
                if (updatedCartSummary != null) {
                    _refreshSummaryHtml(updatedCartSummary);
                }
                if (typeof Checkout !== 'undefined') {
                    Checkout.bindAndEnableCheckoutButtons();
                }
                if (typeof callback === "function") {
                    callback();
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    /* Refresh the whole page if we can't update the cart summary */
                    window.location.reload();
                }
            },
            complete: function () {
                TINK.stopProgress(summary);
                if (typeof buttonVoucher !== 'undefined' && buttonVoucher !== null) {
                    buttonVoucher.prop('disabled', false);
                    TINK.stopProgress(buttonVoucher.parents('.voucher.in-progress.relative'));
                }
            }
        });
    };

    //****************************************************************
    // Json to html
    //****************************************************************

    const _refreshSummaryHtml = function (newCartSummary) {
        cartSummary = newCartSummary;
        _createSummaryHtml();
        _refreshCompletedSteps();
        _bindTipping();
        _bindPromoCode();
        _bindLegalTextsModal();
        _bindReorderModal();
        _bindChangeService();
        _hideMobileCartSummary(!$.isEmptyObject(cartSummary) && cartSummary.inCheckout && checkoutStep !== 6);
        _pushWebviewEvent();
    };

    const _createSummaryHtml = function () {
        if (!$.isEmptyObject(cartSummary)) {
            let inCheckout = cartSummary.inCheckout;
            let inCart = cartSummary.inCart;
            let inOrderDetails = cartSummary.inOrderDetails;

            let $checkoutRightColumn = $(checkoutRightColumnSelector);

            $checkoutRightColumn.empty();
            $('#insertRedeemBox').empty();

            let $summaryMainDiv = $('<div/>', {'class': 'review-wrapper'});
            let $summaryTitle = $('<h3/>', {'class': 'haffermoi-bold'}).append(cartSummary.cartSummaryTitleText);
            let $summaryContent = $('<div/>', {'class': 'review__cart-summary'});

            if (!inCart) {
                $summaryTitle.append($('<span/>', {'class': 'desktop-only'}).append(cartSummary.nbProductsText));
            }

            if (!$.isEmptyObject(cartSummary.priceLines)) {
                cartSummary.priceLines.forEach(function (priceLine) {
                    $summaryContent.append(_createAmountRow(priceLine));
                });
            }

            $summaryContent.append(_createInstacartTipping());
            $summaryContent.append(_createAppliedPromoCodeSection());
            $summaryContent.append(_createAppliedRewardSection());
            $summaryContent.append(_createAddPromoCodeSection());

            // Instant Redeem
            if (inCheckout && cartSummary.instantRedeemDisplayed) {
                if (cartSummary.instantRedeemEnabled) {
                    if (parseInt(cartSummary.instantRedeemAmountAppliedFormattedValue) > 0) {
                        $('#insertRedeemBox').append(_createInstantRedeem(cartSummary.instantRedeemAmountAppliedFormattedValue, cartSummary.redeemableAmountFormattedValue));
                        $summaryContent.append(_createInstantRedeem(cartSummary.instantRedeemAmountAppliedFormattedValue, cartSummary.redeemableAmountFormattedValue));
                    } else if (cartSummary.instantRedeemMinimumExceeded) {
                        $('#insertRedeemBox').append(_createInstantRedeem(cartSummary.redeemableAmountFormattedValue, cartSummary.redeemableAmountFormattedValue));
                        $summaryContent.append(_createInstantRedeem(cartSummary.redeemableAmountFormattedValue, cartSummary.redeemableAmountFormattedValue));
                    } else {
                        $('#insertRedeemBox').append(_createInstantRedeemNotEnough());
                        $summaryContent.append(_createInstantRedeemNotEnough());
                    }
                } else {
                    // Disabled but shown (need to call customer care to fix)
                    $('#insertRedeemBox').append(_createDisabledInstantRedeem());
                    $summaryContent.append(_createDisabledInstantRedeem());
                }
            }

            if (cartSummary.totalPriceLine != null) {
                $summaryContent.append(_createAmountRow(cartSummary.totalPriceLine));
            }

            let $totalLine = $('<div/>', {'class': 'summary__amount amount--total', 'data-total-price': cartSummary.bigTotalPriceLine.value});
            $totalLine.append($('<div/>').append($('<span/>').append(cartSummary.bigTotalPriceLine.description)));
            $totalLine.append($('<div/>').append($('<span/>', {'class': 'cartSummaryTotalWithTax'}).append(cartSummary.bigTotalPriceLine.formattedPrice)));
            $totalLine.append($('<div/>', {'class': inOrderDetails ? 'w-100 amount__note text-align-left' : 'w-100 amount__note'}).append($('<span/>').append(cartSummary.legalMentionText)));
            $summaryContent.append($totalLine);

            if (inCheckout && cartSummary.bigTotalPreAuthPriceLine !== undefined && cartSummary.bigTotalPreAuthPriceLine !== null) {
                let $totalPreAuthLine = $('<div/>', {'class': 'summary__amount amount--total pre-auth--line'});
                $totalPreAuthLine.append($('<div/>').append($('<span/>').append(cartSummary.bigTotalPreAuthPriceLine.description)));
                $totalPreAuthLine.append($('<div/>').append($('<span/>', {'class': 'cartSummaryBigTotalPreAuth'}).append(cartSummary.bigTotalPreAuthPriceLine.formattedPrice)));

                let $totalPreAuthDesc = $('<div/>', {'class': 'summary__amount amount--total pre-auth--desc'});
                $totalPreAuthDesc.append($('<span/>', {'class': 'cartSummaryDesc'}).append(cartSummary.descPreAuthPriceLine.description));

                $summaryContent.append($totalPreAuthLine,$totalPreAuthDesc);
            }

            let $loyaltyTextContainer;
            $loyaltyTextContainer = cartSummary.showLoyaltyPoints ? $('<p>', {'class': 'review__loyalty--earning color-metro-moi-purple'}).append(cartSummary.loyaltyCardText) : '';

            $summaryMainDiv.append($summaryTitle, $summaryContent, $loyaltyTextContainer);
            $summaryMainDiv.append(_createReorderSection());

            $checkoutRightColumn.append($summaryMainDiv);
            if (inCheckout) {

                let $placeOrderBtn = $('<button/>', {
                    'class': 'cta-primary medium checkout-button checkoutButtonsPlaceOrder',
                    'type': 'button'
                });
                $placeOrderBtn.append($('<span/>').append(cartSummary.placeOrderBtnText));
                $placeOrderBtn.append($('<span/>', {'class': 'mobile-tablet-only'}).append(cartSummary.bigTotalPriceLine.formattedPrice));

                if (checkoutStep !== 6) {
                    $placeOrderBtn.prop('disabled', true);
                }
                $checkoutRightColumn.append($placeOrderBtn);
            } else if (inCart) {
                let $continueShoppingContainer = $('<div/>').append($('<a/>', {
                    'class': 'cta-secondary medium w-100 continue-shopping-btn',
                    'href': cartSummary.continueShoppingBtnUrl
                }).append(cartSummary.continueShoppingBtnText));

                // banner picto msg
                let $minimumOrderAmountWarningBanner = $('<div/>', {'class': 'minimum-order-amount-warning-banner alert-container', 'tabindex':'0'});
                let $iconCartWarning = $('<img/>', {'src': '/images/shared/icons/icon-cart-warning.svg', 'alt': ''})
                $minimumOrderAmountWarningBanner.append($iconCartWarning);

                let $warningBannerText = $('<div/>', {'class': 'warning-banner-text'});
                $warningBannerText.append($('<span/>').append(cartSummary.cartBannerText));
                $minimumOrderAmountWarningBanner.append($warningBannerText);

                // Btn for mobile & desktop
                let $checkoutBtnsWrapper = $('<div/>', {'class': 'checkout-buttons'});
                let $checkoutBtnContainer = $('<div/>', {'class': 'cs--checkout'});

                let $checkoutBtn = $('<button/>', {'class': 'cta-primary medium checkout-button', 'type': 'button', 'data-checkout-button': 'all'}).append(cartSummary.cartBtnText, ' ', cartSummary.bigTotalPriceLine.formattedPrice);
                if (!cartSummary.minimumOrderAmountExceeded) {
                    $checkoutBtn.attr('data-disabled', '');
                    $checkoutBtn.attr('disabled', true);
                    $checkoutBtnsWrapper.append($minimumOrderAmountWarningBanner);
                } else {
                    hideMinimumAmountNotExceeded();
                }

                let $continueBtn;
                if (!isInWebview()){
                    $continueBtn = $('<a/>', {'class': 'cta-link continueButton mobile-tablet-only', 'type': 'button', 'href': cartSummary.continueShoppingBtnUrl}).append(cartSummary.continueShoppingBtnText);
                } else {
                    $continueBtn = $('<a/>', {'class': 'cta-link continueButton mobile-webview-continue mobile-tablet-only', 'type': 'button', 'href': '#'}).append(cartSummary.continueShoppingBtnText);
                }

                $checkoutBtnContainer.append($checkoutBtn);

                _updateCartCheckoutReadyCondition($checkoutBtnContainer, $checkoutBtn);
                $checkoutBtnsWrapper.append($checkoutBtnContainer, $continueShoppingContainer);

                // Mobile sticky btn
                let $mobileStickySummaryPlaceOrder = $('<div/>', {
                    'id': 'stickySummary',
                    'class': 'cart-summary--sticky-mobile',
                    'data-checkout-step': '0'
                });

                let $stickySummaryWrapper = $('<div/>', {'class': 'cart-summary--sm--wrapper'});
                let $linkToSummary = $('<a/>', {'href': '', 'class': 'cs--estimated-total focusOnMyAnchor stickySummaryGrandTotal'});
                $linkToSummary.append($('<span/>', {'class': 'cs--text'}).append(cartSummary.bigTotalPriceLine.description));
                $linkToSummary.append($('<span/>', {'class': 'cs--number'}).append(cartSummary.bigTotalPriceLine.formattedPrice));

                $linkToSummary.append($('<span/>', {'class': 'cs--amount--missing'}).append((cartSummary.minimumOrderAmountTextSummary)));

                $linkToSummary.append($('<span/>', {'class': 'cs--valid'}).append((cartSummary.legalMentionText)));

                $stickySummaryWrapper.append($checkoutBtnsWrapper.clone(), $linkToSummary);

                $mobileStickySummaryPlaceOrder.append($stickySummaryWrapper);

                // Desktop btns
                let $desktopPlaceOrderContainer = $('<div/>', {
                    'class': 'summary-sticky sticky-state-trigger except-mobile',
                    'id': 'cart-summary-order-buttons-sticky',
                    'data-cart-summary-reload-order-buttons': true,
                    'data-module': 'stickyState--ie',
                    'data-container': '.summary-wrapper',
                    'data-height-watcher': '.cart--my-basket > .row'
                });

                $desktopPlaceOrderContainer.append($checkoutBtnsWrapper.clone());
                $checkoutRightColumn.append($mobileStickySummaryPlaceOrder, $desktopPlaceOrderContainer);

                $('.mobile-webview-continue').click(function (e) {
                    e.preventDefault();
                    sendCloseWebviewEventToDevice('continueShopping');
                });

                if (!cartSummary.minimumOrderAmountExceeded) {

                    $('.cart-summary--sticky-mobile .cs--checkout .checkout-button').attr('disabled', false);
                    $('.cart-summary--sticky-mobile .checkout-button').html(cartSummary.continueShoppingBtnText);
                    initToast(cartSummary.minimumOrderAmountTextTitleSummary, cartSummary.minimumOrderAmountTextDescriptionSummary);

                    $('.cart-summary--sticky-mobile .cs--checkout .checkout-button').click(function (e) {
                        if (!isInWebview()){
                            window.location.href = cartSummary.continueShoppingBtnUrl;
                        }
                        else{
                            sendCloseWebviewEventToDevice('continueShopping');
                        }
                    });
                } else {
                    let toast = document.getElementById("toast-cart");
                    toast.classList.add("hide");
                }


            }
            TINK.stopProgress($checkoutRightColumn);

            instantRedeemControl(cartSummary);
        }
    };

    function hideMinimumAmountNotExceeded() {
        let queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        let minimumAmountParam = params.get('minimumAmountNotExceeded');
        if (minimumAmountParam === 'true') {
            $('.blockError').addClass('hide');
        }
    }

    const _createAmountRow = function (priceLine) {
        let $amountTextContainer = $('<div/>');
        let bold = priceLine.mainPrice;
        let $amountRow = $('<div/>', {'class': 'summary__amount'});
        let $textSpan = $('<span/>', {'class': bold ? 'primary-bold color-black' : ''}).append(priceLine.description);
        $amountTextContainer.append($textSpan);

        let $amountPriceContainer = $('<div/>');
        let $priceSpan = $('<span/>', {'class': bold ? 'primary-bold color-black' : ''}).append(priceLine.formattedPrice);
        $amountPriceContainer.append($priceSpan);

        $amountRow.append($amountTextContainer, $amountPriceContainer);
        return $amountRow;
    };

    const _createInstacartTipping = function () {
        if (!cartSummary.tippingApplicable) {
            return '';
        }

        //MAIN CONTAINER
        let $instacartTippingContainer = $('<div/>', {'id':'tipping-section','class': cartSummary.tipAppliedSuccess ? 'tipping-container valid-other-tip-submit' : 'tipping-container'});

        //TITLE WITH INFO MODAL
        let $tippingTitle = $('<span/>', {'class': 'primary-bold color-black'}).append(cartSummary.tipSectionText);
        let $tippingInfoContainer = $('<div/>', {'class': 'tipping-info'});
        let $tippingInfoBtn = $('<span/>', {'class': 'tooltip', 'tabindex': '0','aria-description': cartSummary.tipTooltipText}).append('i');
        let $tippingInfoModal = $('<class/>', {'class': 'tooltip-modal'});
        let $tippingInfoModalText = $('<span/>', {'class': 'tooltip-modal-text'}).append(cartSummary.tipTooltipText);
        let $tippingModalContainer = $('<div/>', {'id': 'tooltipSection', 'class': 'tooltip-container', role: 'tooltip' });
        let $appliedTippingPriceLine = cartSummary.tipPriceLine ? _createAmountRow(cartSummary.tipPriceLine) : '';
        $tippingInfoContainer.append($tippingTitle, $tippingModalContainer);
        $tippingModalContainer.append($tippingInfoBtn, $tippingInfoModal);
        $tippingInfoModal.append($tippingInfoModalText);
        $instacartTippingContainer.append($tippingInfoContainer, $appliedTippingPriceLine);

        if (cartSummary.tippingSelectionEnabled && !$.isEmptyObject(cartSummary.tipOptions)) {
            let $tippingChoicesContainer = $('<div/>', {'class': !!cartSummary.tipOptions.find(t => t.otherAmount).selected ? 'tipping-inputs-container other-amount-checked' : 'tipping-inputs-container'});
            let $tippingChoicesHead = $('<div/>', {'class': 'radio--standard mb-2'});

            cartSummary.tipOptions.forEach(function (tipOption, i) {
                let tippingOptionId = 'tippingOption' + i;
                let $tippingRadioLabel = $('<label/>', {'for': tippingOptionId});
                let $tippingRadioInput = $('<input/>', {'type': 'radio', 'id': tippingOptionId, 'name': 'tippingOption', 'value': tipOption.value, 'checked': tipOption.selected, 'aria-label': tipOption.formattedValue});
                let $tippingRadioVisual = $('<span/>', {'class': 'radio--box'});
                let $tippingRadioText = $('<span/>', {'class': 'radio--label primary-bold color-black'}).append(tipOption.formattedValue);

                if (tipOption.otherAmount) {
                    $tippingRadioLabel.append($tippingRadioInput, $tippingRadioVisual, $tippingRadioText);
                    $tippingChoicesHead.append($tippingRadioLabel);

                    let $otherAmountContainer = $('<div/>', {'class': 'radio--standard flex-wrap'});
                    let $tippingOtherAmountContainer = $('<div/>', {'class': 'tipping-other-amount-container', 'id': 'tippingOtherAmountContainer'});
                    let $tippingOtherAmountInputContainer = $('<div/>', {'class': 'tipping-other-amount-input-container ' + (lang === 'en' ? 'left-dollar' : 'right-dollar'), 'id': 'tippingOtherAmountContainer'});
                    let $tippingOtherAmountInput = $('<input/>', {
                        'id': 'tippingOtherAmountInput', 'type': 'text', 'name': 'tippingAmount', 'value': cartSummary.tipAmountFormatted,
                        'onkeyup': 'return CartSummary.manageTippingKeyUpEvent(event);', 'placeholder': lang === 'en' ? '0.00' : '0,00'
                    });
                    let $tipSize = $('<span/>', {'class': 'width-tip invisible-text', 'aria-hidden': 'true'});
                    let $tippingOtherAmountButton = $('<button/>', {
                        'class': cartSummary.tipAppliedSuccess ? 'cta-secondary' : 'cta-primary',
                        'id': 'tippingOtherAmountSubmitBtn',
                        'type': 'button'
                    })
                        .append(cartSummary.tipAppliedSuccess ? cartSummary.tipOtherAmountModify : cartSummary.tipOtherAmountSubmit);

                    let $customMessage = $('<div/>', {'class': 'custom-amount-message'});
                    $customMessage.append($('<span/>', {'class': 'custom-amount-label'}).append(cartSummary.tipOtherAmountLabel));
                    let $customCheck = $('<div/>', {'class': 'custom-amount-check'});

                    $tippingOtherAmountInputContainer.append($tipSize, $tippingOtherAmountInput, $customCheck);
                    $tippingOtherAmountContainer.append($tippingOtherAmountInputContainer, $tippingOtherAmountButton);

                    if (cartSummary.tipAppliedSuccess) {
                        let $messageSuccess = $('<div/>', {'class': 'custom-amount-success'});
                        $messageSuccess.append($('<span/>', {'class': 'custom-amount-success-label'}).append(cartSummary.tipOtherAmountSuccess));
                        $tippingOtherAmountContainer.append($messageSuccess);
                    }

                    $otherAmountContainer.append($customMessage, $tippingOtherAmountContainer);
                    $tippingChoicesContainer.append($tippingChoicesHead, $otherAmountContainer);
                } else {
                    $tippingRadioLabel.append($tippingRadioInput, $tippingRadioVisual, $tippingRadioText);
                    $tippingChoicesHead.append($tippingRadioLabel);
                    $tippingChoicesContainer.append($tippingChoicesHead);
                }
            });

            let $tippingDeliveryModalText = $('<span/>', {'class': 'tip-delivery-text'}).append(cartSummary.tipDeliveryText);
            $tippingChoicesContainer.append($tippingDeliveryModalText);
            $instacartTippingContainer.append($tippingChoicesContainer);
        }

        return $instacartTippingContainer;
    };

    const _createAppliedPromoCodeSection = function () {
        if (!cartSummary.promoCodeApplicable || !cartSummary.promoCodeApplied) {
            return '';
        }

        let $promoCodeContainer = $('<div/>', {'class': 'review__add-promo valid--promo appliedPromoCode', 'tabindex': '0'});
        let $appliedPromoCodeTitle = $('<h3/>').append(cartSummary.promoCodeSectionText);
        let $appliedPromoCodeContainer = $('<div/>', {'class': 'applied-promo-code'});
        let $appliedPromoCodeLine = $('<div/>');
        $appliedPromoCodeLine.append($('<span/>').append(cartSummary.promoCode));

        if (!cartSummary.inOrderDetails) {
            $appliedPromoCodeLine.append($('<button/>', {
                'class': 'remove-promo__code',
                'type': 'button',
                'id': 'removeCodePromoButton',
                'data-coupon-id': cartSummary.promoCodeId
            }).append($('<img/>', {'src': '/images/shared/small/icons/icon-circle-cancel.svg', 'alt': ''})));
        }

        $appliedPromoCodeContainer.append($appliedPromoCodeLine);
        $appliedPromoCodeContainer.append($('<span/>', {'class': 'promo-code-amount'}).append(cartSummary.promoCodeFormattedValue));
        $promoCodeContainer.append($appliedPromoCodeTitle, $appliedPromoCodeContainer);
        return $promoCodeContainer;
    }

    const _createAddPromoCodeSection = function () {
        if (!cartSummary.promoCodeApplicable || cartSummary.promoCodeApplied || cartSummary.inOrderDetails) {
            return '';
        }

        let $promoCodeWrapper = $('<div/>', {'class': 'relative'});
        let $promoCodeContainer = $('<div/>', {'class': 'review__add-promo'});
        let $inputPromoCode = $('<input/>', {'type': 'text', 'id': 'promoCode', 'maxlength': '20', 'onkeyup': 'return CartSummary.managePromoCodeKeyUpEvent(event);'});
        let $buttonApplyPromoCode = $('<button/>', {'class': 'add-promo__apply', 'type': 'button', 'id': 'addCodePromoButton', 'disabled': 'disabled'}).append(cartSummary.applyPromoCodeBtnText);
        let $labelPromoCode = $('<label/>', {'for': 'promoCode'});
        let $buttonAddPromoCode = ($('<button/>', {'class': 'promo-add-code'}).append(cartSummary.addPromoCodeBtnText));
        $labelPromoCode.append($('<span/>', {'class': 'promo-enter-code'}).append(cartSummary.labelPromoCodeBtnText));
        $promoCodeContainer.append($inputPromoCode, $labelPromoCode, $buttonApplyPromoCode);
        $promoCodeWrapper.append($buttonAddPromoCode, $promoCodeContainer);
        return $promoCodeWrapper;

    };

    const _createReorderSection = function () {
        if (!cartSummary.displayReorderBtn) {
            return '';
        }

        let $reorderBtn = $('<button/>', {
            'class': 'cta-primary medium w-100 debounce-250 reorderOrder order-summary-reorder',
            'type': 'button'
        });
        $reorderBtn.prop('disabled', !cartSummary.reorderAllowed);
        $reorderBtn.append($('<span/>').append(cartSummary.reorderBtnText));

        return $reorderBtn;
    };

    const _createAppliedRewardSection = function () {
        if (!cartSummary.voucherApplicable || $.isEmptyObject(cartSummary.vouchers) || !cartSummary.atLeastOneVoucherApplied) {
            return '';
        }

        let $rewardContainer = $('<div/>', {'class': 'review__add-promo valid--promo appliedVouchers', 'tabindex': '0'});
        let $appliedRewardTitle = $('<h3/>').append(cartSummary.rewardDescriptionText);
        $rewardContainer.append($appliedRewardTitle);
        if (cartSummary.vouchers != null) {
            cartSummary.vouchers.forEach(function (voucher) {
                if (voucher.applied) {
                    let $appliedRewardContainer = $('<div/>', {'class': 'applied-promo-code'});
                    let $appliedRewardLine = $('<div/>').append($('<span/>').append(voucher.voucherDescription));
                    $appliedRewardContainer.append($appliedRewardLine);
                    $appliedRewardContainer.append($('<span/>', {'class': 'promo-code-amount'}).append(voucher.remainingBalanceFormatted));
                    $rewardContainer.append($appliedRewardContainer);
                }
            });
        }
        return $rewardContainer;
    };

    const _createInstantRedeem = function (currentAmount, maxAmount) {
        // FILL VARIABLES HERE WITH AJAX RETURN SUCCESS
        let redeemMinAmount = instantRedeemMinimumAmount;
        let redeemMaxAmount = maxAmount;
        let redeemCurrentAmount = TINK.formatCurrency(currentAmount);
        let minAmountText = TINK.formatCurrency(redeemMinAmount);
        let maxAmountText = TINK.formatCurrency(redeemMaxAmount);
        let currentAmountText;
        let redeemToggleText;
        let appliedRedeemText;
        let removeRedeemText;
        let tutoTitle;
        let tutoDescription;
        let tutoClosed;
        let buttonMinusText, buttonPlusText;
        let amountMin = currentAmount * 1 - 1;
        let amountPlus = currentAmount * 1 + 1;

        if (lang == 'en') {
            currentAmountText = 'Apply <span>' + redeemCurrentAmount + '</span>';
            redeemToggleText = 'don\'t forget to redeem !';
            appliedRedeemText = 'Bravo! Your <span>' + redeemCurrentAmount + '</span> reward has been applied.';
            removeRedeemText = 'Cancel'
            tutoClosed = '<img src="/images/shared/small/icons/close--white-bold.svg" alt="Close modal">';
            buttonMinusText = 'Remove 1$ for a total of ' + amountMin;
            buttonPlusText = 'Add 1$ for a total of ' + amountPlus;
        } else {
            currentAmountText = 'Appliquer <span> ' + redeemCurrentAmount + '</span>';
            redeemToggleText = 'C\'est le temps de vous récompenser!\n';
            appliedRedeemText = 'Bravo! Vos <span>' + redeemCurrentAmount + '</span> de récompenses ont été appliqués!';
            removeRedeemText = 'Annuler'
            tutoTitle = 'c\'est facile d\'échanger vos points!';
            tutoDescription = 'Choisissez le montant à échanger et faites glisser la barre. Puis, cliquez sur le bouton "Appliquer mes récompenses" pour l\'appliquer à votre achat.';
            tutoClosed = '<img src="/images/shared/small/icons/close--white-bold.svg" alt="Ferme la fenêtre modale contextuelle">';
            buttonMinusText = 'Retirer 1$ pour un total de ' + amountMin;
            buttonPlusText = 'Ajouter 1$ pour un total de ' + amountPlus;
        }


        if (lang == 'en') {
            tutoTitle = 'redeeming points is easy! ';
            tutoDescription = 'Choose the amount you want to redeem and slide the bar accordingly. Then, click the “Apply” button to apply the reward to your purchase.';
        } else {
            tutoTitle = 'c\'est facile d\'échanger vos points!';
            tutoDescription = 'Choisissez le montant à échanger et faites glisser la barre. Puis, cliquez sur le bouton "Appliquer mes récompenses" pour l\'appliquer à votre achat.';
        }


        // SUBMITTED TEXT
        let $redeemSubmitted = $('<div/>', {
            'class': 'applied-redeem'
        }).append(appliedRedeemText);
        $redeemSubmitted.append($('<button/>', {
            'type': 'button',
            'class': 'remove--redeem cta-link'
        }).append(removeRedeemText));

        // MOI ICON

        let $redeemToggleImg;

        $redeemToggleImg = $('<img/>', {
            'class': 'slider-logo',
            'src': "/images/shared/small/icons/logo-moi-ellipsis-purple.svg"
        }).append(redeemToggleText);

        // TOGGLE BUTTON
        let $redeemToggleBtn = $('<button/>', {
            'class': 'accordion--btn',
            'data-action': 'toggle-accordion',
            'aria-expanded': 'true'
        }).append(redeemToggleText);

        let $redeemToggleBox;

        $redeemToggleBox = $('<div/>', {
            'class': 'accordion--text',
            'style': 'display:block;'
        });

        // RANGE INPUT
        let $instantRedeemContainer = $('<div/>', {
            'class': 'slider-redeem accordion--standalone active',
            'data-feature': 'accordion-default'
        });

        let $instantRedeemFirstPart = $('<div/>', {
            'class': 'slider-redeem-title'
        });

        let $redeemInput;
        $redeemInput = $('<input/>', {
            'type': 'range',
            'min': redeemMinAmount,
            'max': redeemMaxAmount,
            'value': redeemCurrentAmount,
            'class': 'slider redeemRange',
            'onmousedown': "$('.amount-bubble span').css('display', 'flex');",
            'onmouseup': "$('.amount-bubble span').hide();",
            'tabindex': '1',
        });

        let $visualAmountBubble = $('<div/>', {
            'class': 'amount-bubble',
        }).append($('<span/>').append(redeemCurrentAmount));

        // VISUAL AMOUNT GUIDE
        let $redeemRange = $($('<div/>', {
            'class': 'redeem-range',
            'tabindex': '1',
        }).append($('<span/>', {
            'class': 'min-redeem'
        }).html(minAmountText)).append($('<span/>', {
            'class': 'max-redeem'
        }).html(maxAmountText)));

        // MANUAL AMOUNT CONTROL
        let $redeemBtnControl = $('<div/>', {
            'class': 'redeem-actions'
        });

        let $redeemMinusBtn = $('<button/>', {
            'type': 'button',
            'class': 'btn-change-redeem redeem-minus',
            'aria-label': buttonMinusText
        }).append($('<img>', {'src': '/images/main/actions/icon-minus-white.svg'}));

        let $redeemPlusBtn = $('<button/>', {
            'type': 'button',
            'class': 'btn-change-redeem redeem-plus',
            'aria-label': buttonPlusText
        }).append($('<img>', {'src': '/images/main/actions/icon-plus-white.svg'}));

        let $redeemSubmitBtn = $('<button/>', {
            'type': 'button',
            'class': 'redeem-submit'
        }).append(currentAmountText);

        let $redeemError = $('<span/>', {
            'class': 'error-text'
        });

        let $tutoInstantRedeemSection = '';
        let displayTutorial = !TINK.getCookie(instantRedeemTutorialCookieName) && parseInt(cartSummary.instantRedeemAmountAppliedFormattedValue) === 0 && cartSummary.instantRedeemMinimumExceeded;
        if (displayTutorial) {
            $tutoInstantRedeemSection = $('<div>', {'class': 'tuto-redeem-lightbox bg-metro-moi-purple'});
            let $tutoTitle = $('<h2/>', {'class': 'color-white'}).append(tutoTitle);
            let $tutoDescription = $('<p/>', {'class': 'color-white'}).append(tutoDescription);
            let $tutoClosed = $('<button/>', {'class': 'closed-lightbox'}).append(tutoClosed);
            $tutoInstantRedeemSection.append($tutoTitle, $tutoDescription, $tutoClosed);
        }

        $redeemBtnControl.append($redeemMinusBtn, $redeemSubmitBtn, $redeemPlusBtn);
        $redeemToggleBox.append($redeemInput, $redeemRange, $redeemBtnControl, $redeemError, $tutoInstantRedeemSection);
        $instantRedeemFirstPart.append($redeemToggleImg, $redeemToggleBtn);
        $instantRedeemContainer.append($visualAmountBubble, $redeemSubmitted, $instantRedeemFirstPart, $redeemToggleBox);

        //Move the input range to amount value
        $instantRedeemContainer.find('.redeemRange').val(currentAmount);
        return $instantRedeemContainer;
    };

    const _createDisabledInstantRedeem = function () {
        let $errorInstantRedeemSection;
        let errorTitle;
        let errorDescription;
        let phoneNumber;
        let phoneNumberText;

        $errorInstantRedeemSection = $('<div>', {
            'class': 'error-redeem-section bg-metro-moi-purple'
        });
        if (lang == 'en') {
            errorTitle = 'sorry, you can’t redeem your points at the moment';
            errorDescription = 'Please contact our customer care&nbsp;team&nbsp;at';
            phoneNumber = 'tel:18666380020';
            phoneNumberText = '1-866-638-0020';
        } else {
            errorTitle = 'désolé, vous ne pouvez pas échanger vos points pour l\'instant';
            errorDescription = 'Veuillez contacter notre service&nbsp;client&nbsp;au';
            phoneNumber = 'tel:18666380020';
            phoneNumberText = '1-866-638-0020';
        }

        let $errorTitle = $('<h3/>', {'class': 'color-white'}).append(errorTitle);
        let $errorDescription = $('<p/>', {'class': 'color-white'}).append(errorDescription);
        let $errorPhoneNumber = $('<a/>', {'class': 'color-white', 'href': phoneNumber}).append(phoneNumberText);
        $errorInstantRedeemSection.append($errorTitle, $errorDescription, $errorPhoneNumber);
        return $errorInstantRedeemSection;
    };

    const _createInstantRedeemNotEnough = function () {
        let redeemMinAmount = TINK.formatCurrency(0);
        let redeemMaxAmount = TINK.formatCurrency(instantRedeemMinimumAmount);
        let redeemToggleText;
        let redeemDescriptionText;

        if (lang == 'en') {
            redeemToggleText = 'almost there!';
            redeemDescriptionText = 'Reward yourself as soon as you reach <span class="color-metro-moi-purple">' + instantRedeemMinimumPoints + '&nbsp;points</span>';
        } else {
            redeemToggleText = 'vous y êtes presque!';
            redeemDescriptionText = 'Récompensez-vous dès <span class="color-metro-moi-purple">' + instantRedeemMinimumPoints + '&nbsp;points</span>';
        }

        let $redeemDescriptionText = $('<p/>', {
            'class': 'redeem-text-not-enough'
        }).append(redeemDescriptionText);

        // MOI ICON
        let $redeemToggleImg;

        $redeemToggleImg = $('<img/>', {
            'class': 'slider-logo',
            'src': '/images/shared/small/icons/logo-moi-ellipsis-purple.svg',
            'alt': ''
        }).append(redeemToggleText);

        // TOGGLE BUTTON
        let $redeemToggleBtn = $('<button/>', {
            'class': 'accordion--btn',
            'data-action': 'toggle-accordion',
            'aria-expanded': 'true'
        }).append($redeemToggleImg, redeemToggleText);

        let $redeemToggleBox = $('<div/>', {
            'class': 'accordion--text',
            'style': 'display:block;'
        });

        // RANGE
        let $sliderNotEnough;

        $sliderNotEnough = $('<div/>', {
            'class': 'slider'
        });

        let $instantRedeemNotEnoughContainer = $('<div/>', {
            'class': 'slider-redeem redeem-not-enough accordion--standalone active',
            'data-feature': 'accordion-default'
        });

        // VISUAL AMOUNT GUIDE
        let $redeemRange = $($('<div/>', {
            'class': 'redeem-range'
        }).append($('<span/>', {
            'class': 'min-redeem'
        }).html(redeemMinAmount)).append($('<span/>', {
            'class': 'max-redeem'
        }).html(redeemMaxAmount)));

        $redeemToggleBox.append($sliderNotEnough, $redeemRange, $redeemDescriptionText);
        $instantRedeemNotEnoughContainer.append($redeemToggleBtn, $redeemToggleBox);
        return $instantRedeemNotEnoughContainer;
    };

    const _controlAriaLabel = function (redeemCurrentAmount) {

        let buttonMinusText, buttonPlusText;
        let amountMin = redeemCurrentAmount * 1 - 1;
        let amountPlus = redeemCurrentAmount * 1 + 1;

        if (lang == 'en') {
            buttonMinusText = 'Remove 1$ for a total of ' + amountMin;
            buttonPlusText = 'Add 1$ for a total of ' + amountPlus;
        } else {
            buttonMinusText = 'Retirer 1$ pour un total de ' + amountMin;
            buttonPlusText = 'Ajouter 1$ pour un total de ' + amountPlus;
        }

        $('.redeem-minus').attr('aria-label', buttonMinusText);
        $('.redeem-plus').attr('aria-label', buttonPlusText);
    };

    const instantRedeemControl = function (cartSummary) {
        if (!cartSummary.inCheckout || !cartSummary.instantRedeemDisplayed || !cartSummary.instantRedeemEnabled) {
            return false;
        }

        $('.slider-redeem:not(.accordion-default-is_initialized)').accordion_default();

        if (cartSummary.instantRedeemMinimumExceeded) {
            let $inputRange = $('.redeemRange');
            let inputRangeVal = 0;
            let minInputRange = $inputRange.prop('min');
            let maxInputRange = $inputRange.prop('max');
            let $inputRangeInput;

            // MINUS BTN
            $('.redeem-minus').on('click', function () {
                $inputRangeInput = $(this).parents('.accordion--text').find($inputRange);
                inputRangeVal = $inputRangeInput.prop('value');
                inputRangeVal--;

                $inputRange.prop('value', inputRangeVal);
                if (inputRangeVal == minInputRange) {
                    $(this).prop('disabled', true);
                    $('.redeem-plus').prop('disabled', false);
                } else {
                    $('.redeem-plus').prop('disabled', false);
                }
                $('.redeem-submit span, .applied-redeem span').html(TINK.formatCurrency(inputRangeVal));
                $('.redeem-submit').attr('data-redeem-amount', inputRangeVal);

                let value = (inputRangeVal - minInputRange) / (maxInputRange - minInputRange) * 100 - 0.1;
                $inputRange.css('background', 'linear-gradient(to right, #c131a0 0%, #9606b1 ' + value + '%, #e3e3e3 ' + value + '%, #e3e3e3 100%)');

                _controlAriaLabel(inputRangeVal);
            });

            // PLUS BTN
            $('.redeem-plus').on('click', function () {
                $inputRangeInput = $(this).parents('.accordion--text').find($inputRange);
                inputRangeVal = $inputRangeInput.prop('value');
                inputRangeVal++;

                $inputRange.prop('value', inputRangeVal);
                if (inputRangeVal == maxInputRange) {
                    $(this).prop('disabled', true);
                    $('.redeem-minus').prop('disabled', false);
                } else {
                    $('.redeem-minus').prop('disabled', false);
                }
                $('.redeem-submit span, .applied-redeem span').html(TINK.formatCurrency(inputRangeVal));
                $('.redeem-submit').attr('data-redeem-amount', inputRangeVal);

                let value = (inputRangeVal - minInputRange) / (maxInputRange - minInputRange) * 100 - 0.1;
                $inputRange.css('background', 'linear-gradient(to right, #c131a0 0%, #9606b1 ' + value + '%, #e3e3e3 ' + value + '%, #e3e3e3 100%)');

                _controlAriaLabel(inputRangeVal);
            });

            // SUBMIT BTN
            $('.redeem-submit').on('click', function () {
                _addInstantRedeem();
            });

            $('.remove--redeem').on('click', function () {
                _removeInstantRedeem();
            });

            // ON INPUT CHANGE WITH DRAG
            $inputRange.on('input change', function () {
                let newValue = $(this).prop('value');
                $('.redeem-submit span').html(TINK.formatCurrency(newValue));
                if (newValue == minInputRange) {
                    $('.redeem-minus').prop('disabled', true);
                    $('.redeem-plus').prop('disabled', false);
                } else if (newValue == maxInputRange) {
                    $('.redeem-minus').prop('disabled', false);
                    $('.redeem-plus').prop('disabled', true);
                } else {
                    $('.redeem-plus, .redeem-minus').prop('disabled', false);
                }
                $('.applied-redeem span').html(TINK.formatCurrency(newValue));
                $('.redeem-submit').attr('data-redeem-amount', newValue);

                _controlAriaLabel(newValue);
                $('.amount-bubble span').attr('data-redeem-amount', newValue).html(TINK.formatCurrency(newValue));
                let value = (this.value - this.min) / (this.max - this.min) * 100 - 0.1;
                $('.amount-bubble span').css('left', value + '%');
                $(this).css('background', 'linear-gradient(to right, #c131a0 0%, #9606b1 ' + value + '%, #e3e3e3 ' + value + '%, #e3e3e3 100%)');
            });

            // If card has applied instant redeem, we change the view
            if (parseInt(cartSummary.instantRedeemAmountAppliedFormattedValue) > 0) {
                $('.redeem-submit').attr('data-redeem-amount', cartSummary.instantRedeemAmountAppliedFormattedValue);
                $('.slider-redeem').addClass('isSubmit');
            } else {
                $('.redeem-submit').attr('data-redeem-amount', cartSummary.redeemableAmountFormattedValue);
                if (cartSummary.redeemableAmountFormattedValue === maxInputRange) {
                    $('.redeem-plus').prop('disabled', true);
                }
                if (minInputRange === maxInputRange) {
                    $('.redeem-minus').prop('disabled', true);
                }
            }
        }

        // Instant redeem tutorial
        $('.closed-lightbox, .checkoutButtonsPlaceOrder, .redeem-submit').on('click', function () {
            $('.tuto-redeem-lightbox').fadeOut();
            TINK.setCookie(instantRedeemTutorialCookieName, true, instantRedeemTutorialCookieDurationDays);
        });
    };

    const _refreshCompletedSteps = function () {
        if (!$.isEmptyObject(cartSummary)) {
            $('.checkoutLoyaltyPoints').html(cartSummary.loyaltyPoints);
            $('.checkoutLoyaltyPointsText').html(cartSummary.loyaltyCardText);
            $('.checkoutTotalWithTax').text(cartSummary.bigTotalPriceLine.formattedPrice);
            $('.checkoutTipAmount').html(cartSummary.tipPriceLine ? cartSummary.tipPriceLine.formattedPrice : '');
        }
    };

    //****************************************************************
    // Express Delivery checkout ready condition
    //****************************************************************

    const _updateCartCheckoutReadyCondition = function ($checkoutBtnContainer, $checkoutBtn) {
        let $miniCartSpontaneousSection = $('.mini-cart-side-panel--spontaneous');
        let maxEntriesCriteria = $miniCartSpontaneousSection.attr('data-max-entries-criteria');

        if (typeof maxEntriesCriteria !== 'undefined') {
            let totalEntries = $miniCartSpontaneousSection.attr('data-total-entries');
            if (typeof totalEntries !== 'undefined') {
                if (parseInt(totalEntries) > parseInt(maxEntriesCriteria)) {
                    // Disable checkout button
                    $checkoutBtn.text(maxItemTotalExceededMessage.replace('{0}', totalEntries).replace('{1}', maxEntriesCriteria));
                    $checkoutBtn.prop('disabled', true);
                    // Define change service button
                    let $changeServiceBtn = $('<button/>', {'class': 'openStoreLocator cs--ed-change-service', 'type': 'button'});
                    $changeServiceBtn.append($('<span/>').append(cartSummary.changeServiceBtnText));
                    $changeServiceBtn.attr('service-and-timeslot-target', serviceUrl);
                    // Add change service button to checkout container
                    $checkoutBtnContainer.append($changeServiceBtn);
                }
            }
        }
    };

    const _bindChangeService = function () {
        let $changeServiceBtn = $('.cs--ed-change-service');
        if ($changeServiceBtn.length) {
            $changeServiceBtn.on('click', function (e) {
                ServiceTimeslot.openServiceAndTimeslot.bind(this)();
            });
        }
    };

    //****************************************************************
    // Promo code
    //****************************************************************

    const _showPromoField = function () {
        $('#promoCode').focus();
    }

    const _addPromoCode = function (e) {
        e.preventDefault();
        var promoCode = $('#promoCode').val();
        if (promoCode.trim().length === 0) {
            $('#addCodePromoButton').attr('disabled', 'disabled');
            return;
        }

        _disablePlaceOrder(true);

        var $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        TINK.sessionAjax({
            url: promoCodeAjaxUrl + '/' + promoCode,
            type: 'POST',
            success: function (promoCodeResponse) {
                TINK.stopProgress($container);
                if (promoCodeResponse.promoCodeApplied) {
                    _updateCartSummary(null);
                } else {
                    let $addPromoCodeContainer = $('.review__add-promo');
                    let $addPromoCodeBtn = $('.promo-add-code')
                    $addPromoCodeContainer.addClass('has--error');
                    $addPromoCodeBtn.addClass('hide');
                    $addPromoCodeContainer.find('label[for=promoCode]').after($('<span>', {'class': 'error-text'}).append(promoCodeResponse.errorMessage));
                    _disablePlaceOrder(checkoutStep !== 6);
                    $('#promoCode').focus();
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _removePromoCode = function (e) {
        e.preventDefault();
        _disablePlaceOrder(true);

        var $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        var promoCode = $(this).attr('data-coupon-id');
        TINK.sessionAjax({
            url: promoCodeAjaxUrl + '/' + promoCode,
            type: 'DELETE',
            success: function () {
                _updateCartSummary();
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _bindPromoCode = function () {
        $('#addCodePromoButton').on('click', _addPromoCode);
        $('#removeCodePromoButton').on('click', _removePromoCode);
        $('.promo-add-code').on('click', _showPromoField);
    };

    const _managePromoCodeKeyUpEvent = function (e) {
        let $addPromoCodeContainer = $('.review__add-promo');
        $addPromoCodeContainer.removeClass('has--error');
        $addPromoCodeContainer.find('.error-text').remove();
        let $target = $(e.target);

        if ($target.val().length >= 1) {
            $addPromoCodeContainer.addClass('minimumValueStyle');
            $('#addCodePromoButton').prop('disabled', false);

        } else {
            $addPromoCodeContainer.removeClass('minimumValueStyle');
            $('#addCodePromoButton').prop('disabled', true);
        }

        if (e.which === 13 || e.keyCode === 13) {

            _addPromoCode(e);
            return false;
        }
        return true;
    };

    //****************************************************************
    // Instant Redeem
    //****************************************************************

    const _addInstantRedeem = function () {
        let pointValue = $('.redeem-submit').attr('data-redeem-amount');
        if (pointValue.trim().length === 0) {
            return;
        }

        _disablePlaceOrder(true);
        let csrf =  $("meta[name='_csrf']").attr("content");
        let $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        $.ajax({
            url: instantRedeemAjaxUrl,
            type: 'POST',
            contentType: 'application/json',
            headers: {
                'X-CSRF-TOKEN': csrf
            },
            data: JSON.stringify({'pointValue': pointValue}),
            success: function (instantRedeemResponse) {
                TINK.stopProgress($container);

                if (instantRedeemResponse.instantRedeemApplied) {
                    _updateCartSummary(null);
                } else {
                    let $instantRedeemContainer = $('.slider-redeem');
                    $instantRedeemContainer.addClass('has--error');
                    $instantRedeemContainer.find('.error-text').text(instantRedeemResponse.errorMessage);

                    _disablePlaceOrder(checkoutStep !== 6);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _removeInstantRedeem = function () {
        _disablePlaceOrder(true);

        let $container = $(checkoutRightColumnSelector);
        if ($container.length) {
            TINK.inProgress($container);
        }

        TINK.sessionAjax({
            url: instantRedeemAjaxUrl,
            type: 'DELETE',
            contentType: 'application/json',
            success: function () {
                _updateCartSummary(null);
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    //****************************************************************
    // Tipping
    //****************************************************************

    const _updateCartTip = function (tipAmount, tipPercentage, deliveryPartner) {
        if (!tipAmount && !tipPercentage) {
            return;
        }
        if (isNaN(tipAmount) || isNaN(tipPercentage)) {
            return;
        }

        _disablePlaceOrder(true);

        let $tippingOtherAmountInputContainer = $('.tipping-other-amount-input-container');
        let $container = $(checkoutRightColumnSelector);

        if ($container.length) {
            TINK.inProgress($container);
        }

        $('.tipping-inputs-container .error--text').remove(); // clear previous errors
        $tippingOtherAmountInputContainer.removeClass('input-error');
        $('#tipping-section').removeClass('valid-other-tip-submit');

        TINK.sessionAjax({
            url: tippingAjaxUrl,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({tipAmount: tipAmount, tipPercentage: tipPercentage, deliveryPartner: deliveryPartner}),
            success: function (tipResponse) {
                TINK.stopProgress($container);

                if (tipResponse.tipApplied) {
                    _updateCartSummary(null, true);
                } else {
                    let $tipContainer = $('.tipping-inputs-container');
                    $tipContainer.append($('<div>', {'class': 'error--text color-error-message'}).append(tipResponse.errorMessage));
                    $tippingOtherAmountInputContainer.addClass('input-error');
                    _disablePlaceOrder(checkoutStep !== 6);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    window.location.reload();
                }
            }
        });
    };

    const _bindTipping = function () {
        $('input[name="tippingOption"]').on('change', function () {
            let $otherAmountContainer = $('#tippingOtherAmountContainer');
            let $tippingInputsContainer = $('.tipping-inputs-container');

            if ($(this).val() === instacartOtherAmountValue) {
                $tippingInputsContainer.addClass('other-amount-checked');
                $('#tippingOtherAmountInput').trigger('focus');
                $otherAmountContainer.prepend($('label.other-amount-label'));
            } else {
                $tippingInputsContainer.removeClass('other-amount-checked');
                let tipPercentage = $(this).val().trim();
                _updateCartTip(null, tipPercentage, deliveryPartner);
            }
            $('.width-tip').html(TINK.sanitizeNumber($('input#tippingOtherAmountInput').val()));
        });

        $('button#tippingOtherAmountSubmitBtn').on('click', function () {
            $('.custom-amount-success-label').remove();
            let tipAmount = TINK.sanitizeNumber($('input#tippingOtherAmountInput').val());
            _updateCartTip(tipAmount, null, deliveryPartner);
        });

        $('button.toggle-other-amount').on('click', function () {
            $('input[name="tippingOption"]').prop('checked', false);
            $('input[name="tippingOption"][value = ' + instacartOtherAmountValue + ']').prop('checked', true).trigger('change');
        })

        $('#tippingOtherAmountInput').on('change', function () {
            $('.tipping-container').removeClass('valid-other-tip-submit');
            $('.tipping-other-amount-input-container').removeClass('input-error');
        });

        $('input#tippingOtherAmountInput').mask(lang === 'en' ? "000.00" : "000,00", {reverse: true});
        $('.width-tip').html(TINK.sanitizeNumber($('input#tippingOtherAmountInput').val()));
    };

    const _manageTippingKeyUpEvent = function (e) {
        $('.width-tip').html(TINK.sanitizeNumber($('input#tippingOtherAmountInput').val()));
        if ($('.width-tip').text() == '') {
            $('.width-tip').css('visibility', 'hidden');
        } else {
            $('.width-tip').css('visibility', 'unset');
        }
        if (e.which === 13 || e.keyCode === 13) {
            $('.custom-amount-success-label').remove();
            let tipAmount = TINK.sanitizeNumber($('input#tippingOtherAmountInput').val());
            _updateCartTip(tipAmount, null);
            return false;
        }
        return true;
    };

    //****************************************************************
    // Legal texts
    //****************************************************************

    const _bindLegalTextsModal = function () {
        $('button.showCheckoutLegalTexts').on('click', function () {
            $(checkoutLegalModalSelector).remodal().open();
            TINK.updateStatusNotification(window['modalOpenMessage']);
            event.preventDefault();
        });
    };

    //****************************************************************
    // Util
    //****************************************************************

    const _disableCheckout = function (disable) {
        jQuery('[data-checkout-button=all]').each(function () {
            jQuery(this).prop('disabled', disable);
        });
    };

    const _disablePlaceOrder = function (disable) {
        var $checkoutButtonPlaceOrder = $('button.checkoutButtonsPlaceOrder');
        if ($checkoutButtonPlaceOrder.length) {
            $checkoutButtonPlaceOrder.prop('disabled', disable);
        }
    };

    const _hideMobileCartSummary = function (hide) {
        if (hide) {
            $('.checkoutRight').addClass('except-mobile-tablet');
            $('.anchor-tipping-container').addClass('hide');
        } else {
            $('.checkoutRight').removeClass('except-mobile-tablet');
            $('.anchor-tipping-container').removeClass('hide');
        }
    };

    const _manageStickySummarySize = function () {
        // Reposition footer-sticky-sac based on the summary height
        const stickySummary = document.getElementById('stickySummary');
        const container = document.querySelector('.metro-footer');
        const helpButton = document.getElementById('footer-sticky-sac');

        if (stickySummary === null || container === null || helpButton === null) {
            return false;
        }

        let elementHeight = stickySummary.clientHeight;
        const helpButtonHeightInitial = helpButton.clientHeight;
        const gutter = 20;

        updatePosition(elementHeight);

        new ResizeSensor(stickySummary, function () {
            elementHeight = stickySummary.clientHeight;
            updatePosition(elementHeight);
        });

        function updatePosition(elementHeight) {
            container.setAttribute('style', `padding-bottom:${elementHeight + helpButtonHeightInitial + gutter}px;`);
            helpButton.setAttribute('style', 'bottom: ' + (elementHeight + gutter) + 'px;');
        }
    };

    //****************************************************************
    // Reorder
    //****************************************************************

    const _bindReorderModal = function () {
        let $reorderBtn = $('#cartSummaryContainer').find('.reorderOrder');
        $reorderBtn.on('click', function () {
            OrderDetails.reorder($(this));
        });
    };


    //****************************************************************
    // Webview mode
    //****************************************************************

    const _pushWebviewEvent = function () {
        if (isInWebview() && !$.isEmptyObject(cartSummary) && !cartSummary.inOrderDetails) {
            sendNewQtyInCartEventToDevice(cartSummary.cartNbItems);
        }
    };

    //****************************************************************
    // Expose
    //****************************************************************

    return {
        bindLegalTextsModal: _bindLegalTextsModal,
        disableCheckout: _disableCheckout,
        disablePlaceOrder: _disablePlaceOrder,
        init: _init,
        hideMobileCartSummary: _hideMobileCartSummary,
        managePromoCodeKeyUpEvent: _managePromoCodeKeyUpEvent,
        manageTippingKeyUpEvent: _manageTippingKeyUpEvent,
        refreshSummaryHtml: _refreshSummaryHtml,
        updateCartSummary: _updateCartSummary
    };
}();

$(function () {
    CartSummary.init();
});